import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 'fit-content',
      cursor: 'default',
      borderRadius: theme.shape.borderRadiusSmall,
    },
    selectable: {
      cursor: 'pointer',
    },
    selected: {},
    disabled: {},
    default: {
      backgroundColor: COLORS.gray.gray80,
      // The background fills the border, so the border is invisible, but the chip is as tall as an
      // outlined one.
      border: '1px solid transparent',

      '&$disabled': {
        backgroundColor: COLORS.gray.gray70,
      },
      '&:hover': {
        backgroundColor: COLORS.gray.gray80,
      },
    },
    outlined: {
      borderColor: COLORS.gray.gray60,
      color: COLORS.gray.black,

      '&$disabled': {
        backgroundColor: COLORS.gray.gray70,
      },

      '& svg': {
        color: COLORS.gray.gray30,
      },

      '&:hover': {
        backgroundColor: COLORS.primary.light,

        '&:is($closeIcon)': {
          color: COLORS.gray.gray30,
        },
      },

      '&$selected': {
        borderColor: COLORS.primary.default,
        color: COLORS.primary.default,
        backgroundColor: COLORS.primary.silver,

        '& svg:is($checkIcon)': {
          color: COLORS.primary.default,
        },

        '&:hover': {
          backgroundColor: COLORS.primary.silver,
          '& svg:is($checkIcon)': {
            color: COLORS.primary.active,
          },
          '&:not($disabled)': {
            borderColor: COLORS.primary.active,
            color: COLORS.primary.active,
          },
        },
      },
    },
    small: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      padding: theme.spacing(0.125, 0.75),
      height: 'auto',
    },
    medium: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      padding: theme.spacing(0.375, 0.75),
      height: 'auto',
    },
    iconSmall: {},
    icon: {
      height: theme.typography.pxToRem(16),
      width: theme.typography.pxToRem(16),

      '&$iconSmall': {
        height: theme.typography.pxToRem(12),
        width: theme.typography.pxToRem(12),
      },
    },
    plusIcon: {},
    checkIcon: {},
    closeIcon: {
      transform: 'rotate(135deg)',
    },
  }),
  { name: 'CustomChip' }
);
